import type { FactionId } from './types';

export interface SkillDef {
  id: string;
  displayName: string;
  faction: FactionId | 'builtin';
  cost: number;      // factionXP threshold; 0 for built-in
  /** Used only by cooldown-style built-in skills. Charging skills set this to 0. */
  cooldownMs: number;
  description: string;
}

export const SKILL_CATALOG: SkillDef[] = [
  {
    id: 'spread-shot',
    displayName: '擴散三連發',
    faction: 'builtin',
    cost: 0,
    cooldownMs: 5000,
    description: '空白鍵釋放 — 三顆子彈扇形射擊',
  },
  {
    id: 'meteor-cannon',
    displayName: '隕星砲台',
    faction: 'celestial',
    cost: 100,
    cooldownMs: 10000,
    description: '⚡ 星算門技能 — 1 鍵釋放,五顆強化砲彈扇射',
  },
  {
    id: 'runic-shield',
    displayName: '古語護盾',
    faction: 'runic',
    cost: 100,
    cooldownMs: 0, // uses charging instead of cooldown
    description: '🔮 符文門技能 — 1-4 鍵釋放,吸收 3 次傷害',
  },
  {
    id: 'frost-cannon',
    displayName: '冰川凍結',
    faction: 'elemental',
    cost: 150,
    cooldownMs: 0,
    description: '🌀 自然門技能 — 凍結所有敵人 2 秒(期間每秒 5 傷害,自身子彈傷害減半)',
  },
  {
    id: 'shadow-drone',
    displayName: '暗影無人機',
    faction: 'techno',
    cost: 120,
    cooldownMs: 0,
    description: '🤖 機械門技能 — 標記敵人,下一發子彈追加 8 點傷害',
  },
  {
    id: 'eternal-sunshine',
    displayName: '永恆陽光',
    faction: 'dominion',
    cost: 130,
    cooldownMs: 0,
    description: '🏰 疆域門技能 — 攻速加倍 10 秒',
  },
  // ── Lv2/3 skills (stubs — effect semantics completed by faction agents in W3) ──
  {
    id: 'celestial-2',
    displayName: '星辰鎖定',
    faction: 'celestial',
    cost: 250,
    cooldownMs: 0,
    description: '⚡ 星算門技能 — 接下來 5 顆子彈必中最近敵人',
  },
  {
    id: 'celestial-3',
    displayName: '時空爆裂',
    faction: 'celestial',
    cost: 500,
    cooldownMs: 0,
    description: '⚡ 星算門技能 — 5 秒慢動作:敵人速度 ×0.3',
  },
  {
    id: 'runic-2',
    displayName: '靈魂封印',
    faction: 'runic',
    cost: 300,
    cooldownMs: 0,
    description: '🔮 符文門技能 — 4 秒全敵人停止(boss 減半)',
  },
  {
    id: 'runic-3',
    displayName: '禁忌咒言',
    faction: 'runic',
    cost: 600,
    cooldownMs: 0,
    description: '🔮 符文門技能 — 魔王下一次大招無效',
  },
  {
    id: 'techno-2',
    displayName: '電磁脈衝',
    faction: 'techno',
    cost: 350,
    cooldownMs: 0,
    description: '🤖 機械門技能 — 全屏 EMP:敵人 3 秒眩暈',
  },
  {
    id: 'techno-3',
    displayName: '量子穿透砲',
    faction: 'techno',
    cost: 700,
    cooldownMs: 0,
    description: '🤖 機械門技能 — 1 發超大子彈,穿透所有,boss 護盾無效',
  },
  {
    id: 'elemental-2',
    displayName: '業火焚天',
    faction: 'elemental',
    cost: 300,
    cooldownMs: 0,
    description: '🌀 自然門技能 — 10 秒持續火柱,路過敵人 -1 HP/0.3s',
  },
  {
    id: 'elemental-3',
    displayName: '自然覺醒',
    faction: 'elemental',
    cost: 650,
    cooldownMs: 0,
    description: '🌀 自然門技能 — 15 秒 buff:玩家所有傷害 ×3',
  },
  {
    id: 'dominion-2',
    displayName: '大地震怒',
    faction: 'dominion',
    cost: 380,
    cooldownMs: 0,
    description: '🏰 疆域門技能 — 4 秒全屏停 + 全敵人 -10 HP',
  },
  {
    id: 'dominion-3',
    displayName: '聖域降臨',
    faction: 'dominion',
    cost: 750,
    cooldownMs: 0,
    description: '🏰 疆域門技能 — 15 秒全免疫 + 攻速 ×2',
  },
];

export function getSkill(id: string): SkillDef | undefined {
  return SKILL_CATALOG.find(s => s.id === id);
}
